import React from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { baseURL } from "../../http";
import { customAlert } from "../SweetAlertCommon/Custom";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import "../TPACoursePage/CourseNamePage/tpacoursepage.css";

function ExamUploadFromTemplate({ DBApi, close, update }) {
  //--------------------------------------------------------------------------------
  //handle Upload the file for exam data (excel and csv)
  //--------------------------------------------------------------------------------

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming the data is present in the first sheet (index 0)
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to JSON format
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      // Required columns
      const requiredColumns = [
        "top_category",
        "exam_category",
        "state_or_department",
        "exam_name",
        "authority_url",
        "overview",
        "syllabus",
        "eligibility",
        "fees.general",
        "fees.sc",
        "fees.st",
        "fees.others",
      ];

      // Modify JSON data to include only the required columns and additional fields
      const modifiedData = jsonData.map((row) => {
        const modifiedRow = {};

        // Add required columns with values from the uploaded data
        requiredColumns.forEach((header) => {
          modifiedRow[header] = row[header] || ""; // Set value from uploaded data or empty string if missing
        });

        // Add additional fields
        modifiedRow["Created_By"] = localStorage.getItem("HTES_user_id");
        modifiedRow["Created_date"] = new Date().toISOString();
        modifiedRow["Modified_By"] = localStorage.getItem("HTES_user_id");
        modifiedRow["Modified_date"] = new Date().toISOString();

        return modifiedRow;
      });

      try {
        // Send the modified JSON data to the backend
        const response = await axios.post(baseURL + DBApi, modifiedData);
        console.log(response);

        // Check if the response status is OK (200)
        if (response.status === 200) {
          customAlert(
            "",
            "Data uploaded successfully and dropped the duplicate exam entry",
            "success"
          );
          update(true);
          close();
        } else {
          customAlert(
            "",
            "Error uploading data. Please check the template and database connectivity",
            "error"
          );
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          customAlert(
            "",
            "Duplicate record found. Please check and try again.",
            "warning"
          );
        } else {
          customAlert(
            "",
            "Error uploading data. Please check the template and database connectivity",
            "error"
          );
        }
      }
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div>
      {/* ______________________Jsx start______________________ */}
      <input
        type="file"
        accept=".xlsx, .xls,.csv"
        onChange={handleUpload}
        style={{ display: "none" }}
        id="upload-file"
      />
      <label htmlFor="upload-file">
        <div>
          <FileUploadIcon
            className="course-name-template-addboxixon-style"
            color="primary"
            fontSize="large"
          />
          <br />
          <span>
            Upload
            <br />
            Exam Data
          </span>
        </div>
      </label>
      {/* ______________________end______________________ */}
    </div>
  );
}

export default ExamUploadFromTemplate;
